import { ClockCircleOutlined } from '@ant-design/icons';
import { ChevronLeftIcon } from '@heroicons/react/outline';
import { Typography } from 'antd';
import Head from 'next/head';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { useRecoilValue } from 'recoil';

import { user } from '../../atoms/user';
import RewardSlider from '../../components/ReferPageComp/RewardSlider';
import ButtonDefault, {
  ButtonVariants,
} from '../../components/shared/basic/button';
import { pageTitle } from '../../components/shared/basic/customHead';
import { ShouldRender } from '../../components/shared/basic/ShouldRender';
import CustomLoader from '../../components/shared/Loading';
import { User } from '../../utils/interfaces/User';
import { coins } from '../../../assets';

const RewardsPage = () => {
  const router = useRouter();
  const userData = useRecoilValue<User | undefined>(user);
  const [loading, setLoading] = useState(false);

  return (
    <div>
      <Head>
        <title>{pageTitle('Rewards')}</title>
      </Head>
      <div className='overflow-hidden flex flex-col gap-y-14 md:gap-y-20 xl: xl:gap-y-28 '>
        <div className='flex justify-center mx-5 lg:mx-12 translate-y-16 pb-8 xl:pb-16 border-b border-cartBgColor'>
          <div className='flex justify-between max-w-3xl'>
            <div className='flex flex-col'>
              <div
                onClick={() => router.push('/')}
                className='flex gap-x-2 items-center mb-6 cursor-pointer group'
              >
                <button className='z-10 w-8 h-8 p-2 rounded-full text-white flex justify-center items-center bg-cartBgColor'>
                  <ChevronLeftIcon className='text-white w-4 h-4 xl:w-7 xl:h-7' />
                </button>
                <ShouldRender
                  check={
                    typeof window !== 'undefined' && window.innerWidth > 768
                  }
                >
                  <span className='text-base font-medium group-hover:text-underline'>
                    Back To Home
                  </span>
                </ShouldRender>
              </div>

              <Typography.Title
                level={1}
                className='font-medium text-sm md:text-base md:pb-2'
              >
                Z COINS
              </Typography.Title>
              <span className='text-4xl md:text-[56px] font-semibold text-white'>
                {userData?.balance || 0}
              </span>
              <span className='w-full pr-4 md:w-2/3 text-[#9F9EA6] pt-2 font-medium text-xs md:text-base'>
                Spend coins to claim rewards, offers from top brands, and other
                perks.
              </span>
              <div className='flex gap-x-4'>
                <div className='w-min mt-4'>
                  <ButtonDefault
                    size={1}
                    onClick={() => router.push('/rewards/history')}
                    variant={ButtonVariants.GRAY}
                    className='w-min p-1'
                  >
                    <span className='flex text-xs gap-x-2 px-1 whitespace-nowrap'>
                      <ClockCircleOutlined className='text-sm' /> History
                    </span>
                  </ButtonDefault>
                </div>
                <div className='w-min mt-4'>
                  <ButtonDefault
                    size={1}
                    onClick={() => router.push('/reward-store/')}
                    variant={ButtonVariants.PRIMARY}
                    className='w-min p-1'
                  >
                    <span className='flex text-xs gap-x-2 px-1 whitespace-nowrap'>
                      My Rewards
                    </span>
                  </ButtonDefault>
                </div>
              </div>
            </div>
            <div className='pt-6'>
              <Image src={coins} alt='coins' width={120} height={120} />
            </div>
          </div>
        </div>
        <div className='border-b relative md:border-none lg:border-b h-[450px] over md:h-[600px] lgMd:h-[600px]  translate-y-10 md:translate-y-0  border-cartBgColor '>
          <RewardSlider setLoading={setLoading} loading={loading} type='book' />
          <div className='border-b border-dropDownMenuBg absolute bottom-7 md:bottom-[5vh] xl:-bottom-20 left-0 w-full' />
        </div>
        <div className='h-[450px] md:h-[550px]  lgMd:h-[600px] md:-mt-0 translate-t-10 md:translate-t-0  z-0'>
          <RewardSlider
            setLoading={setLoading}
            loading={loading}
            type='course'
          />
        </div>
        <ShouldRender check={loading}>
          <CustomLoader />
        </ShouldRender>
      </div>
    </div>
  );
};

export default RewardsPage;
